import { EntityState } from "@ngrx/entity";

import { DirectoryEntity } from "../entities";

export interface DirectoryState extends EntityState<DirectoryEntity> {
  isLoading: boolean,
  isLoaded: boolean,
  isFailure: boolean,
  total: number,
  prevUrl: string,
  nextUrl: string,
  companyDirectoryIds: number[],
  followerDirectoryIds: number[],
  followingDirectoryIds: number[],
  isCompanyLoaded: boolean,
  isFollowerLoaded: boolean,
  isFollowingLoaded: boolean,
  companyDirectoryTotal: number,
  followerDirectoryTotal: number,
  followingDirectoryTotal: number,
  isCompanyForceLoad: boolean,
  isFollowerForceLoad: boolean,
  isFollowingForceLoad: boolean
}
